import OperationService from '@/features/operation/service';

export default {
  exitsOperationName(payload) {
    return OperationService.searchOperationByName(payload)
      .then((lista) => {
        let exists = false;
        if (lista.length === 0) {
          return { exists };
        }
        lista.forEach((item) => {
          exists = exists || item.title === payload;
        });
        return { exists };
      });
  },
  createOperation(model) {
    return OperationService.createOperation(model);
  },
};



// WEBPACK FOOTER //
// ./src/features/operation-new/service.js